import { graphql } from "/@/generated";

export const GetDashboardCountsDocument = graphql(`
  query GetDashboardCounts(
    $dentistId: String!
    $dentalOfficeId: String!
    $byOffice: Boolean!
    $deliveredFrom: Timestamp!
    $deliveredTo: Timestamp!
  ) {
    drafts: getOrdersCountByDentistId(
      dentistId: $dentistId
      filter: { status: { included: [DRAFT] } }
    ) @skip(if: $byOffice)
    officeDrafts: getOrdersCountByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      filter: { status: { included: [DRAFT] } }
    ) @include(if: $byOffice)
    total: getOrdersCountByDentistId(
      dentistId: $dentistId
      filter: { status: { excluded: [DRAFT] } }
    ) @skip(if: $byOffice)
    inProgress: getOrdersCountByDentistId(
      dentistId: $dentistId
      filter: { status: { excluded: [DRAFT, DELIVERED] } }
    ) @skip(if: $byOffice)
    waitingForAnswer: getOrdersCountByDentistId(
      dentistId: $dentistId
      filter: { status: { included: [AWAITING_VALIDATION] } }
    ) @skip(if: $byOffice)
    deliveredThisMonth: getOrdersCountByDentistId(
      dentistId: $dentistId
      filter: {
        status: { included: [DELIVERED] }
        delivered: { from: $deliveredFrom, to: $deliveredTo }
      }
    ) @skip(if: $byOffice)
    officeTotal: getOrdersCountByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      filter: { status: { excluded: [DRAFT] } }
    ) @include(if: $byOffice)
    officeInProgress: getOrdersCountByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      filter: { status: { excluded: [DRAFT, DELIVERED] } }
    ) @include(if: $byOffice)
    officeWaitingForAnswer: getOrdersCountByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      filter: { status: { included: [AWAITING_VALIDATION] } }
    ) @include(if: $byOffice)
    officeDeliveredThisMonth: getOrdersCountByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      filter: {
        status: { included: [DELIVERED] }
        delivered: { from: $deliveredFrom, to: $deliveredTo }
      }
    ) @include(if: $byOffice)
  }
`);

export const DashboardDraftFragment = graphql(`
  fragment DashboardDraft on OrderModel {
    id
    reference
    createdAt
    updatedAt
    patient {
      firstName
      lastName
    }
    products {
      id
      type
    }
  }
`);

export const GetDashboardLastDraftDocument = graphql(`
  query GetDashboardLastDraft(
    $dentistId: String!
    $dentalOfficeId: String!
    $byOffice: Boolean!
  ) {
    lastDrafts: getOrdersByDentistId(
      dentistId: $dentistId
      pageSize: 1
      filter: { status: { included: [DRAFT] } }
      sort: LAST_ACTIVITY
    ) @skip(if: $byOffice) {
      nodes {
        ...DashboardDraft
      }
    }
    officeLastDrafts: getOrdersByDentalOfficeId(
      dentalOfficeId: $dentalOfficeId
      pageSize: 1
      filter: { status: { included: [DRAFT] } }
      sort: LAST_ACTIVITY
    ) @include(if: $byOffice) {
      nodes {
        ...DashboardDraft
      }
    }
  }
`);
